import {Button, Icon, Notification, Text} from '@smart/react-components';
import type {FormEventHandler} from 'react';
import React, {useRef, useState} from 'react';
import FormStyles from '../../common/form-styles.module.scss';
import {scrollToRef} from '../../common/helpers';
import type {ViewsFetchingToPostForm} from '../../common/types';
import {AppModelContext} from '../../components/app';
import Fields from '../../components/easy-form/fields';
import {useAPI} from '../../hooks/use-api';
import {useViews} from '../../hooks/use-views';
import Styles from './index.module.scss';

export interface IUnsubscriptionFormState {
  channelToken: string;
  subscriptionID: string;
}

interface ISubsList {
  [index: string]: string;
}

const viewName: ViewsFetchingToPostForm = `unsubscription`;

export default function Unsubscription(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState<string>();
  const [submitAttempt, setSubmitAttempt] = useState(false);
  const apiFetch = useAPI(viewName, true);
  const {channelToken, subscriptionID} = useViews();
  const cmsTranslations =
    React.useContext(AppModelContext).cms.formsFeatureAppUnsubscribeUi || {};
  /*const validationLabel =
    React.useContext(AppModelContext).cms.formsFeatureAppValidation_ErrorsUi ||
    {};*/
  // const cfmError = validationLabel.validations_serverError?.toString();
  const formWrapperRef = useRef<HTMLDivElement>(null);
  const apiTranslations =
    React.useContext(AppModelContext).cms.apiErrorMessageKeys || {};

  let formData: IUnsubscriptionFormState;
  if (channelToken && subscriptionID) {
    formData = {
      channelToken,
      subscriptionID,
    };
  }
  const getSubscriptionName = () => {
    const subsList: ISubsList = {
      smart_NLwithDOI_EU:
        ` ` + cmsTranslations.subscription_type_newsletter + `.`,
      smart_RMS_NLwithDOI_EU: ` ` + cmsTranslations.subscription_type_rms + `.`,
      smart_VIP_NLwithDOI_EU:
        ` ` + cmsTranslations.subscription_type_rms_vip + `.`,
    };
    if (subscriptionID) {
      return subsList[subscriptionID];
    }

    return ``;
  };

  const onSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();

    setLoading(true);
    setServerError(undefined);

    try {
      await apiFetch(formData);
      setSubmitAttempt(true);
    } catch (error) {
      console.error(error);
      setServerError(error as string);
      scrollToRef(formWrapperRef);
    } finally {
      setLoading(false);
    }
  };
  const setValueFromAEM = () => {
    let apiErrorMessage = ``;
    let translatedString;

    const getStringFromAEM = apiTranslations.errorMessageKeys?.filter((e) => {
      return e?.includes(serverError as any);
    }, serverError);

    if (!getStringFromAEM) {
      apiErrorMessage = apiTranslations.generalFallbackErrorMessage as string;
    } else {
      translatedString = getStringFromAEM && getStringFromAEM[0]?.split(`:`);
      apiErrorMessage = translatedString && (translatedString[1] as any);
    }
    return apiErrorMessage;
  };

  return (
    <div className={Styles.unsubscription} ref={formWrapperRef}>
      <Fields.Wrapper
        translationPrefix={viewName}
        disabled={loading || submitAttempt}
      >
        <form onSubmit={onSubmit}>
          <Text className={Styles.heading} variant="hl-200" as="h1">
            {cmsTranslations.unsubscription_message}
          </Text>
          <Button
            className={Styles.button}
            type="submit"
            variant="primary"
            disabled={loading || submitAttempt}
          >
            <Icon icon="close-with-circle" mode={200} />
            {cmsTranslations.submitButton || `Unsubscribe`}
          </Button>
        </form>
        {serverError && (
          <Notification
            signal="error"
            className={FormStyles.serverError}
            onOpenChange={(open) => {
              if (!open) {
                setServerError(undefined);
              }
            }}
          >
            <Notification.Text>{setValueFromAEM()}</Notification.Text>
          </Notification>
        )}

        {submitAttempt && (
          <Notification
            signal="success"
            className={FormStyles.serverError}
            onOpenChange={(open) => {
              if (!open) {
                setSubmitAttempt(false);
              }
            }}
          >
            <Notification.Headline>
              {cmsTranslations.success_label || `Success`}
            </Notification.Headline>
            <Notification.Text>
              {cmsTranslations.success_text! + getSubscriptionName()}
            </Notification.Text>
          </Notification>
        )}
      </Fields.Wrapper>
    </div>
  );
}
